export const fuzzyMatch = (text: string, searchToken: string): boolean => {
  const normalizedText = String(text).trim().toLowerCase();
  const normalizedSearchToken = String(searchToken).trim().toLowerCase();
  return normalizedText.includes(normalizedSearchToken);
};
